"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "m16.228 4.914-.707.707L18.35 8.45l.707-.707a2 2 0 0 0-2.829-2.829m-2.121 2.122 2.819 2.818-.687.707-.717-.697.717.697-.283.29-.748.767c-.621.635-1.455 1.487-2.307 2.35-.85.863-1.721 1.74-2.414 2.423-.347.342-.652.64-.89.865-.202.19-.438.41-.597.514-.307.202-1.006.61-1.642.947a13 13 0 0 1-.915.447c-.13.054-.281.113-.427.151a1.4 1.4 0 0 1-.32.047c-.08.002-.465.01-.781-.306a1.07 1.07 0 0 1-.308-.734c-.003-.13.016-.244.03-.314.03-.149.08-.303.13-.436.101-.278.25-.613.414-.943.164-.333.353-.682.54-.989.173-.285.388-.606.608-.826z"
}), 'PenFilled');
